import { useContext } from 'react';
import { bankInfoContext } from '../contexts/BankInfo.context';
/**
 * Hook that returns bank info context
 *
 * @returns BankInfoContext
 */
var useBankInfo = function () { return useContext(bankInfoContext); };
export default useBankInfo;
